var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{attrs:{"icon-pack":"feather","icon":"icon-plus"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('addDream')}}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }